/* Dekompilier-Service: BSP (Bytes) -> .map-Text im Valve-220-Format. Für Editor und Kommandozeile. */
import Decomp from '../formats/decomp.ts';
import type { DecompOptions, DecompStats } from '../formats/decomp.ts';
import { toBuffer } from './check.ts';
import type { Bytes } from './check.ts';

export interface DecompileResult { mapText: string; stats: DecompStats; warnings: string[] }

export function decompileBsp(bytes: Bytes, opts?: Partial<DecompOptions>): DecompileResult {
  const r = Decomp.decompile(toBuffer(bytes), opts);
  return { mapText: Decomp.toMapText(r), stats: r.stats, warnings: r.warnings };
}
